var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c("ac-data-table", {
        ref: "table",
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          "item-class": _vm.classObj,
          "item-key": "uid",
          "fixed-header": "",
          "footer-props": _vm.footer,
          "items-per-page": 50,
          height: _vm.winsize.height - 145 - 48,
          search: _vm.search,
          "can-select": (item) => !_vm.row_readonly(item),
          "can-delete": (item) => !_vm.row_readonly(item),
          "remove-bulk": _vm.bulkRemove,
          "bulk-mode": _vm.bulkMode,
          title: "Currency Kind",
        },
        on: {
          "update:search": function ($event) {
            _vm.search = $event
          },
          "update:bulkMode": function ($event) {
            _vm.bulkMode = $event
          },
          "update:bulk-mode": function ($event) {
            _vm.bulkMode = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-2",
                    attrs: { color: "primary" },
                    on: { click: _vm.row_create },
                  },
                  [_vm._v(" New Currency Kind ")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-2",
                    attrs: { color: "accent" },
                    on: { click: _vm.exportData },
                  },
                  [_vm._v(" EXPORT TO JSON ")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "item.item",
            fn: function ({ item }) {
              return [_vm._v(" " + _vm._s(item.item?.key || "") + " ")]
            },
          },
          {
            key: "item.group",
            fn: function ({ item }) {
              return [_vm._v(" " + _vm._s(item.group?.key || "") + " ")]
            },
          },
          {
            key: "item.modifier",
            fn: function ({ item }) {
              return [_vm._v(" " + _vm._s(item.modifier || "") + " ")]
            },
          },
          {
            key: "item.shared",
            fn: function ({ item }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      item.shared === true || item.shared === 1
                        ? "true"
                        : "false"
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.collectEffect",
            fn: function ({ item }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      item.collectEffect === true || item.collectEffect === 1
                        ? "true"
                        : "false"
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.maps",
            fn: function ({ item }) {
              return [
                _c(
                  "div",
                  [
                    item.maps?.length > 3
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: {
                              bottom: "",
                              "content-class": "currency-kind-page__ttip",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "currency-kind-page__item-maps-coll",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.copyMaps(item.maps)
                                                },
                                              },
                                            },
                                            "span",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_vm._v(" [Map Collection] ")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v(_vm._s(item.maps.join(", ")))])]
                        )
                      : _c(
                          "span",
                          { staticClass: "currency-kind-page__item-maps" },
                          [
                            _vm._v(
                              " " + _vm._s(item.maps?.join(", ") || "-") + " "
                            ),
                          ]
                        ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "div",
                  { staticStyle: { "white-space": "nowrap" } },
                  [
                    _vm.row_readonly(item)
                      ? _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "", color: "green" },
                            on: {
                              click: function ($event) {
                                return _vm.row_view(item)
                              },
                            },
                          },
                          [_vm._v(" mdi-eye ")]
                        )
                      : item.locked
                      ? _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "", color: "orange" },
                            on: {
                              click: function ($event) {
                                return _vm.row_update(item)
                              },
                            },
                          },
                          [_vm._v(" mdi-pencil ")]
                        )
                      : _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "", color: "green" },
                            on: {
                              click: function ($event) {
                                return _vm.row_update(item)
                              },
                            },
                          },
                          [_vm._v(" mdi-pencil ")]
                        ),
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "", color: "teal lighten-1" },
                        on: {
                          click: function ($event) {
                            return _vm.row_copy(item)
                          },
                        },
                      },
                      [_vm._v(" mdi-content-copy ")]
                    ),
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: {
                          disabled: item.global || item.sharedScope,
                          small: "",
                          color: "blue",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.row_export(item)
                          },
                        },
                      },
                      [_vm._v("mdi-briefcase-upload")]
                    ),
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: {
                          disabled: _vm.row_readonly(item),
                          small: "",
                          color: "red",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.row_remove(item)
                          },
                        },
                      },
                      [_vm._v(" mdi-delete ")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "no-results",
            fn: function () {
              return [
                _c(
                  "v-alert",
                  { attrs: { value: true, color: "blue-grey", dense: "" } },
                  [
                    _vm._v(
                      ' Your search for "' +
                        _vm._s(_vm.search) +
                        '" found no results. '
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c("r-currency-kind-dialog", { ref: "dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }